/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{padding-top:50px;display:flex;align-items:center;justify-content:center;width:100%;background:linear-gradient(to bottom,#e9ecef,transparent) top no-repeat;background-size:100% 50px}.center[_ngcontent-%COMP%]{max-width:60%}.password-reset[_ngcontent-%COMP%]{text-align:center}a[_ngcontent-%COMP%]:link, a[_ngcontent-%COMP%]:visited{color:#495058;text-decoration:none}a[_ngcontent-%COMP%]:hover{color:#495058;text-decoration:underline}"];
export { styles as styles };
